export const state = () => ({
  settings: null
})

export const getters = {
  hasActiveSubscription (state, getters, routeState) {
    return routeState.auth.user.subscription.is_active && routeState.auth.user.subscription.plan_id
  },
  hasActiveMusicSubscription (state, getters, rootState) {
    return rootState.auth.user.subscription.is_music && getters.hasActiveSubscription
  },
  hasMusicPremium (state, getters, rootState) {
    return getters.hasActiveMusicSubscription ||
      new Date() < new Date(rootState.auth.user.subscription.music_pass_expired_at)
  },
  platform (state, getters, rootState) {
    if (rootState.auth.user.acting_user) {
      return {
        platform: rootState.auth.user.acting_user.platform,
        platform_id: rootState.auth.user.acting_user.platform_id
      }
    }

    return {
      platform: rootState.auth.user.platform,
      platform_id: rootState.auth.user.platform_id
    }
  },
  currentId (state, getters, rootState) {
    if (rootState.auth.user.acting_user) {
      return rootState.auth.user.acting_user.id
    }

    return rootState.auth.user.id
  }
}

export const mutations = {
  SET_SETTINGS (state, settings) {
    state.settings = settings
  },
  UPDATE_SETTING (state, update) {
    state.settings.user_settings[update.key] = update.value
  }
}

export const actions = {
  getAlertSettings ({ commit, getters, state }) {
    if (state.settings !== null) {
      return state.settings
    }

    return this.$axios
      .get(`v1/users/${getters.currentId}/alert-configs/`)
      .then(({ data }) => {
        commit('SET_SETTINGS', data)
        commit('socket/ADD_EVENT', {
          eventName: 'event-settings-updated',
          handler (event, data) {
            for (const key of Object.keys(data)) {
              commit('UPDATE_SETTING', { key, value: data[key] })
            }
          }
        }, { root: true })
        commit('socket/ADD_EVENT', {
          eventName: 'browser-source-updated',
          handler (event, data) {
            commit('SET_SETTINGS', data)
          }
        }, { root: true })

        return data
      })
  }
}
